import React from 'react';
import AdminFieldHelp from '../admin/AdminFieldHelp';
import cx from './cx';

const AppFormLabel = ({
  htmlFor,
  children,
  help,
  helpExample,
  className = 'form-label',
  required = false,
}) => (
  <label htmlFor={htmlFor} className={cx(className, 'admin-form-label')}>
    <span className="admin-form-label__text">
      {children}
      {required && <span className="text-danger ms-1" aria-hidden>*</span>}
    </span>
    {(help || helpExample) && (
      <AdminFieldHelp help={help} helpExample={helpExample} />
    )}
  </label>
);

export default AppFormLabel;
